import { Aurelia, autoinject, bindable, computedFrom } from 'aurelia-framework';
import { CostCenterServiceLink, LinkedMappingsService } from "./linked-mappings-service";
import { ServiceNodeModel } from '../service-structure-service';

@autoinject
export class LinkedCostCentersList {
	@bindable service: ServiceNodeModel;
	@bindable serviceStructureId: string;

	@computedFrom("linkedMappingsService.costCenterServiceLinksCache")
	get linkedCostCenters(): CostCenterServiceLink[] {
		const costCenters = this.calculateLinkedCostCenters();
		this.service.hasSubViewContent = costCenters.length > 0;
		return costCenters;
	}

	private calculateLinkedCostCenters(): CostCenterServiceLink[] {

		const allLinks = this.linkedMappingsService.costCenterServiceLinksCache;
		if (!allLinks) {
			return [];
		}
		return allLinks.filter((link: CostCenterServiceLink) =>
			link.serviceId === this.service.id &&
			!link.isCostCenterIgnored &&
			(!link.dimensionValueIds || link.dimensionValueIds.length == 0)
		);
	}

	constructor(private linkedMappingsService: LinkedMappingsService) {
	}

	removeLinkedCostCenter(link: CostCenterServiceLink): void {
		this.linkedMappingsService.removeLinkedCostCenter(link, this.serviceStructureId);
	}
}
